import api from '@/utils/api';

/**
 * Get a quote pdf by id and type (quote or enquiry)
 * @param {string} quoteId - The quote id
 * @returns {Promise}
 */
const getQuoteTotalApi = (quoteId) => api.get(`/quote/${quoteId}/total`);

export default getQuoteTotalApi;
